import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    fill: theme.palette.primary1,
    cursor: 'pointer',

    '& rect': {
      fill: theme.palette.primary1,
    },

    '&:hover': {
      '& path': {
        fill: theme.palette.primary1,
      },
      '& rect': {
        fill: theme.palette.lightGrey,
      },
    },
  },
  active: {
    fill: theme.palette.lightGrey,
    cursor: 'pointer',
    '& rect': {
      fill: theme.palette.lightGrey,
    },

    '& path': {
      fill: theme.palette.primary1,
    },
  },
}));
